const $ = require('jquery');

export function popup() {
    $('[data-mfp-help]').magnificPopup({
        type:'inline',
    });

    $('.js-popup-video').magnificPopup({
        type: 'iframe',
    }); 

    $('a.image-gallery__link').magnificPopup({
        type: 'image',
        tLoading: 'Loading image #%curr%...',
        mainClass: 'mfp-img-mobile',
        gallery: {
	        enabled: true,
	        navigateByImgClick: true,
	        preload: [0,1],
	        tCounter: '<span>%curr% / %total%</span>' // markup of counter
        },
        image: {
	        tError: '<a href="%url%">The image #%curr%</a> could not be loaded.',
	        titleSrc: 'data-caption'
        },
    });
};